import React from "react";
import "./ProgressIndicator.css";

interface Props {
  state: number;
  lineNum: number;
}

const StatusLine = (props: Props) => {
    return (
        <div
            className={
            props.state > props.lineNum
                ? "status-line-active"
                : "status-line-inactive"
            }
        >
            {" "}
        </div>
    );

};

export default StatusLine;
